import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

interface StyleProps {
  open?: boolean;
  value?: string;
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  filterSelect: {
    width: 'fit-content',
    height: 34,
    color: colors.darkestBlue,
    textAlign: 'center',
    border: `1px solid ${colors.darkestBlue}`,
    boxSizing: 'border-box',
    borderRadius: '8px',
    fontSize: 14,
    gap: 8,
    fontWeight: 700,
    '&:hover': {
      backgroundColor: colors.powderBlue,
    },
    '& div:first-child': {
      padding: '7px 36px 7px 16px',
    },
    '& svg': {
      transform: ({ open }) => open && 'rotate(180deg)',
      pointerEvents: 'none',
      position: 'absolute',
      right: 13,
    },
  },
  bgColor: {
    backgroundColor: ({ value }) => (value ? colors.white : 'transparent'),
  },
}));
